import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  selectTab(event) {
    const selectedTab = event.target.closest("[data-tab-item]")
    if (!selectedTab || !this.element.contains(selectedTab)) return

    event.preventDefault()
    this.activateTab(selectedTab.dataset.tabItem)
  }

  next(event) {
    event.preventDefault()

    const currentPanel = event.currentTarget.closest("[data-tabs-panel]")
    if (!currentPanel) return

    const nextPanel = currentPanel.nextElementSibling
    if (!nextPanel?.dataset?.tabsPanel) return

    this.activateTab(nextPanel.dataset.tabsPanel)
    window.scrollTo({ top: nextPanel.offsetTop, behavior: "smooth" })
  }

  activateTab(tabName) {
    this.tabItemTargets.forEach((tab) => tab.setAttribute("aria-selected", "false"))
    this.panelTargets.forEach((panel) => panel.classList.add("hidden"))

    const selectedTab = this.tabItemTargets.find((tab) => tab.dataset.tabItem === tabName)
    const panel = this.panelTargets.find((element) => element.dataset.tabsPanel === tabName)

    if (selectedTab) selectedTab.setAttribute("aria-selected", "true")
    if (panel) {
      panel.classList.remove("hidden")
      panel.setAttribute("aria-selected", "true")
    }
  }

  static targets = ["tabItem", "panel"]
}
